// Use $ instead of $ without replacing global $
(function ($) {
  $(document).ready(function () {
    if ($(".hero-banner").length > 0) {
      setTimeout(function () {
        $(".hero-banner .bg-img .first-animation").addClass("animation-remove");
      }, 500);
      $(".hero-banner .bg-img .second-animation").addClass("animation-start");
      $(".hero-banner .bg-img video").css({ "transition": "all 0.5s ease" });
    }
    if ($(".hero-banner.solutions").length > 0) {
      setTimeout(function () {
        $(".hero-banner .bg-img .second-animation").addClass("animation-start");
      }, 10);
    }
  });
})(jQuery); 
